import Fuse from 'fuse.js';

export const createFuzzySearch = <T>(
    items: T[],
    keys: Array<{ name: string; weight: number }>,
) => {
    const options = {
        includeScore: true,
        threshold: 0.4,
        distance: 100,
        keys,
    };

    return new Fuse(items, options);
};

export const fuzzyFilter = <T>(
    items: T[],
    searchText: string,
    keys: Array<{ name: string; weight: number }>,
): T[] => {
    if (!searchText) return items;

    const fuse = createFuzzySearch(items, keys);
    const results = fuse.search(searchText);

    return results.map(result => result.item);
};

export const smartFilter = <T>(
    items: T[],
    searchText: string,
    keys: Array<{ name: string; weight: number }>,
): T[] => {
    if (!searchText) return items;

    const trimmedSearch = searchText.trim();
    const searchWords = trimmedSearch.toLowerCase().split(' ').filter(word => word.length > 0);

    // Use exclusive filtering for multi-word searches to be more precise
    if (searchWords.length > 1) {
        return items.filter(item => {
            // Check if ALL search words are present in at least one of the searchable fields
            return searchWords.every(searchWord => {
                return keys.some(key => {
                    const fieldValue = (item as any)[key.name];
                    if (!fieldValue) return false;

                    const fieldText = fieldValue.toString().toLowerCase();
                    return fieldText.includes(searchWord);
                });
            });
        });
    }

    // For single word searches, use fuzzy filtering for better UX
    const fuse = createFuzzySearch(items, keys);
    const results = fuse.search(trimmedSearch);
    return results.map(result => result.item);
};
